import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: `${feConfig.baseRoute}reportapp/`,
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    // 登录
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/ReportApp/components/Login'], resolve),
      meta: { title: '登录' }
    },
    {
      path: '/customer/service',
      name: 'CustomerService',
      component: resolve => require(['@/views/ReportApp/components/CustomerService/index'], resolve),
      meta: { title: '咨询客服', hideHeader: true }
    },
    // 健康商城
    {
      path: '/health/mall',
      name: 'HealthMall',
      component: resolve => require(['@/views/ReportApp/components/HealthMall'], resolve),
      meta: { title: '橙心易购', showPayRecord: false, hideHeader: true }
    },
    // 认领考试列表
    // {
    //   path: '/claim/exam/list',
    //   name: 'ClaimExamList',
    //   component: resolve => require(['@/views/ReportApp/components/ClaimExam/ClaimExamList'], resolve),
    //   meta: { title: '认领考试', showPayRecord: false }
    // },
    // 认领考试的试卷列表
    // {
    //   path: '/claim/exam/paper',
    //   name: 'ClaimExamPaper',
    //   component: resolve => require(['@/views/ReportApp/components/ClaimExam/ClaimExamPaper'], resolve),
    //   meta: { title: '根据答题卡认领', showPayRecord: false }
    // },
    {
      path: '/course/page',
      name: 'CoursePage',
      component: resolve => require(['@/views/ReportApp/components/Course/index'], resolve),
      meta: { title: '会员专享课程', hideHeader: true }
    },
    {
      path: '/course/detail',
      name: 'CourseDetail',
      component: resolve => require(['@/views/ReportApp/components/Course/components/CourseDetail'], resolve),
      meta: { title: '课程详情', hideHeader: true }
    },
    {
      path: '/get-trial',
      name: 'GetTrial',
      component: resolve => require(['@/views/ReportApp/components/GetTrial'], resolve),
      meta: { title: '领取试用' }
    },
    {
      path: '/trial-qrcode',
      name: 'TrialQrcode',
      component: resolve => require(['@/views/ReportApp/components/TrialQrcode'], resolve),
      meta: { title: '试用二维码' }
    },
    // 辅助运营 千万注册用户导航选择页面
    {
      path: '/registerednavigation',
      name: 'RegisteredNavigation',
      component: resolve => require(['@/views/ReportApp/components/RegisteredNavigation'], resolve),
      meta: { title: '好分数学习助手', hideHeader: true }
    },
    // AI升学宝/AI 升学练习测试 报名页面
    {
      path: '/aisignup',
      name: 'AiSignUp',
      component: resolve => require(['@/views/ReportApp/components/AiSignUp'], resolve),
      meta: { title: '好分数学习助手', hideHeader: true }

    },
    // 找回密码
    {
      path: '/password/recover',
      name: 'findPassword',
      component: resolve => require(['@/views/ReportApp/components/FindPassword'], resolve),
      meta: { title: '找回密码' }
    },
    // 重置密码
    {
      path: '/password/reset',
      name: 'resetPassword',
      component: resolve => require(['@/views/ReportApp/components/ResetPassword'], resolve),
      meta: { title: '重置密码' }
    },
    // 账号注册
    {
      path: '/register',
      name: 'registerAccount',
      component: resolve => require(['@/views/ReportApp/components/RegisterAccount'], resolve),
      meta: { title: '账号注册', hideHeader: true }
    },
    // 非微信环境下账号注册成功页
    {
      path: '/register/success',
      name: 'registerSuccess',
      component: resolve => require(['@/views/ReportApp/components/RegisterSuccess'], resolve),
      meta: { title: '注册成功' }
    },
    // 服务条款
    {
      path: '/register/terms',
      name: 'registerTerms',
      component: resolve => require(['@/views/ReportApp/components/RegisterTerms'], resolve),
      meta: { title: '服务条款' }
    },
    // 绑定学生
    {
      path: '/unbind',
      name: 'unBindStudent',
      component: resolve => require(['@/views/ReportApp/components/LoginBindInfo'], resolve),
      meta: { title: '完善学生信息' }
    },
    // 绑定学生
    {
      path: '/bind',
      name: 'bindStudent',
      component: resolve => require(['@/views/ReportApp/components/BindStudent'], resolve),
      meta: { title: '绑定学生档案' }
    },
    // 通过证件号绑定学生
    {
      path: '/bind/id',
      name: 'bindStudentById',
      component: resolve => require(['@/views/ReportApp/components/BindStudentById'], resolve),
      meta: { title: '绑定学生' }
    },
    // 通过学校绑定学生
    {
      path: '/bind/school',
      name: 'bindStudentBySchool',
      component: resolve => require(['@/views/ReportApp/components/BindStudentBySchool'], resolve),
      meta: { title: '绑定学生' }
    },
    // 授权码验证
    {
      path: '/bind/authorization',
      name: 'authorization',
      component: resolve => require(['@/views/ReportApp/components/Authorization'], resolve),
      meta: { title: '授权码验证' }
    },
    // idsp 北斗接入路由
    {
      path: '/reportEntrance',
      name: 'reportEntrance',
      component: resolve => require(['@/views/ReportApp/components/ReportEntrance'], resolve),
      meta: { hideHeader: true }
    },
    // 通过手机号绑定
    {
      path: '/bind/phone',
      name: 'bindPhone',
      component: resolve => require(['@/views/ReportApp/components/BindPhone'], resolve),
      meta: { title: '绑定手机号' }
    },
    // 填写验证码
    {
      path: '/verification',
      name: 'fillVerifyCode',
      component: resolve => require(['@/views/ReportApp/components/FillVerifyCode'], resolve),
      meta: { title: '填写验证码' }
    },
    // 微信登录设置密码
    {
      path: '/bind/wechatPwd',
      name: 'bindWechatPwd',
      component: resolve => require(['@/views/ReportApp/components/BindWechatPwd'], resolve),
      meta: { title: '设置密码' }
    },
    // 最新考试报告
    // {
    //   path: '/report/list',
    //   name: 'reportList',
    //   component: resolve => require(['@/views/ReportApp/components/ReportList'], resolve),
    //   meta: { title: '最新考试报告', showPayRecord: true }
    // },
    // 联考报告
    // {
    //   path: '/unitedExamReport',
    //   name: 'unitedExamReport',
    //   component: resolve => require(['@/views/ReportApp/components/UnitedExamReport'], resolve),
    //   meta: { title: '联考报告', showPayRecord: false, hideHeader: true }
    // },
    // 历次考试
    // {
    //   path: '/report/history',
    //   name: 'reportHistory',
    //   component: resolve => require(['@/views/ReportApp/components/ReportHistoryList'], resolve),
    //   meta: { title: '报告列表' }
    // },
    // 会员购买
    {
      path: '/report/members',
      name: 'reportMembers',
      component: resolve => require(['@/views/ReportApp/components/ReportMembers'], resolve),
      meta: { title: '会员购买', showPayRecord: false, hideHeader: true }
    },
    // 报告详情
    // {
    //   path: '/report/detail',
    //   name: 'reportDetail',
    //   component: resolve => require(['@/views/ReportApp/components/ReportDetail'], resolve),
    //   meta: { title: '报告详情', showPayRecord: true }
    // },
    // 勋章墙
    // {
    //   path: '/report/detail/medalWall',
    //   name: 'reportMedalWall',
    //   component: resolve => require(['@/views/ReportApp/components/studentMedalWall'], resolve),
    //   meta: { title: '考试评价' }
    // },
    // 试题解析
    // {
    //   path: '/report/analysis',
    //   name: 'paperAnalysis',
    //   component: resolve => require(['@/views/ReportApp/components/PaperAnalysis'], resolve),
    //   meta: { title: '试题解析' }
    // },
    // 试题解析：查看错题
    // {
    //   path: '/report/analysis/wrong',
    //   name: 'wrongItemAnalysis',
    //   component: resolve => require(['@/views/ReportApp/components/WrongItemAnalysis'], resolve),
    //   meta: { title: '试题解析' }
    // },
    // 购买记录
    // {
    //   path: '/record',
    //   name: 'payRecord',
    //   component: resolve => require(['@/views/ReportApp/components/PayRecord'], resolve),
    //   meta: { title: '购买记录' }
    // },
    // 教师端分享页：注册列表
    {
      path: '/share/register',
      name: 'registerList',
      component: resolve => require(['@/views/ReportApp/components/RegisterList'], resolve),
      meta: { title: '好分数帮家长', showPayRecord: false, hideHeader: true }
    },
    // 答题卡
    // {
    //   path: '/report/answerSheet',
    //   name: 'answerSheet',
    //   component: resolve => require(['@/views/ReportApp/components/AnswerSheet'], resolve),
    //   meta: { title: '答题卡', showPayRecord: true }
    // },
    // 购买页。注：由于支付目录的配置，需要在/report目录下才能发起支付。
    {
      path: '/report/pay',
      name: 'reportPayment',
      component: resolve => require(['@/views/ReportApp/components/ReportPayment'], resolve),
      meta: { title: '选择开通商品' }
    },
    // 购买完成后的提示分享页
    {
      path: '/report/pay-success',
      name: 'paymentSuccess',
      component: resolve => require(['@/views/ReportApp/components/PaymentSuccess'], resolve),
      meta: { title: '支付完成' }
    },
    // 购买完成后的分享页
    {
      path: '/share',
      name: 'reportShare',
      component: resolve => require(['@/views/ReportApp/components/ReportShare'], resolve),
      meta: { title: '你查分了么' }
    },
    // 错题本售卖
    {
      path: '/report/wrongCopies',
      name: 'wrongCopies',
      component: resolve => require(['@/views/ReportApp/components/SaleWrongCopies'], resolve),
      meta: { title: '填写信息' }
    },
    {
      path: '/report/schoolWrongCopies',
      name: 'schoolWrongCopies',
      component: resolve => require(['@/views/ReportApp/components/SchoolWrongCopies'], resolve),
      meta: { title: '填写信息' }
    },
    {
      path: '/report/schoolDeployCopies',
      name: 'schoolDeployCopies',
      component: resolve => require(['@/views/ReportApp/components/SchoolDeployCopies'], resolve),
      meta: { title: '填写信息' }
    },
    {
      path: '/report/payWrongCopies',
      name: 'payWrongCopies',
      component: resolve => require(['@/views/ReportApp/components/PayWrongCopies'], resolve),
      meta: { title: '填写信息' }
    },
    // 错题本支付成功
    {
      path: '/wrongCopies/pay-success',
      name: 'wrongCopiesPaySuccess',
      component: resolve => require(['@/views/ReportApp/components/WrongCopiesPaySuccess'], resolve),
      meta: { title: '支付成功', hideHeader: true }
    },
    // 新版ctb支付页
    {
      path: '/report',
      name: 'wrongCopiesIndex',
      component: resolve => require(['@/views/ReportApp/components/CTB/Index'], resolve),
      children: [
        // 中转页
        {
          path: 'wrongCopiesTurn',
          name: 'wrongCopiesTurn',
          component: resolve => require(['@/views/ReportApp/components/CTB/PageTurn'], resolve),
          meta: { title: '错题本详情', hideHeader: true }
        },
        {
          path: 'newCtbDetail',
          name: 'newCtbDetail',
          component: resolve => require(['@/views/ReportApp/components/CTB/Detail'], resolve),
          meta: { title: '错题本详情', hideHeader: true }
        },
        {
          path: 'taocanDetail',
          name: 'taocanDetail',
          component: resolve => require(['@/views/ReportApp/components/CTB/TaocanDetail'], resolve),
          meta: { title: '错题本详情', hideHeader: true }
        },

        {
          path: 'new-pay-success',
          name: 'newPaySuccess',
          component: resolve => require(['@/views/ReportApp/components/CTB/PaySuccessPage'], resolve),
          meta: { title: '支付成功', hideHeader: true }
        },
        {
          path: 'group-progress',
          name: 'groupProgress',
          component: resolve => require(['@/views/ReportApp/components/CTB/GroupProgress'], resolve),
          meta: { title: '拼团进度', hideHeader: true }
        },
        {
          path: 'confirm',
          name: 'confirmInfo',
          component: resolve => require(['@/views/ReportApp/components/CTB/ConfirmInfo'], resolve),
          meta: { title: '确认订单', hideHeader: true }
        },
        {
          path: '/newCtbSeniorOne',
          name: 'newCtbSeniorOne',
          component: resolve => require(['@/views/ReportApp/components/CTB/newCtbSeniorOne'], resolve),
          meta: { title: '高一错题本', hideHeader: true }
        },
        {
          path: '/newCtbSeniorTwo',
          name: 'newCtbSeniorTwo',
          component: resolve => require(['@/views/ReportApp/components/CTB/newCtbSeniorTwo'], resolve),
          meta: { title: '高二错题本', hideHeader: true }
        },
        {
          path: '/newCtbSeniorThree',
          name: 'newCtbSeniorThree',
          component: resolve => require(['@/views/ReportApp/components/CTB/newCtbSeniorThree'], resolve),
          meta: { title: '高三错题本', hideHeader: true }
        },
        {
          path: '/newCtbPayQrcode',
          name: 'newCtbPayQrcode',
          component: resolve => require(['@/views/ReportApp/components/CTB/PayQrcode'], resolve),
          meta: { title: '错题本详情', hideHeader: true }
        },
        {
          path: 'confirmProduct',
          name: 'confirmProduct',
          component: resolve => require(['@/views/ReportApp/components/CTB/ConfirmProduct'], resolve),
          meta: { title: '确定商品', hideHeader: true }
        },
        // 新版错题本售卖
        {
          path: '/exam/ctb',
          name: 'ExamCtb',
          component: resolve => require(['@/views/ReportApp/components/ExamCtb/ExamCtb'], resolve),
          meta: { title: '个性化错题本', hideHeader: true }
        },
        // 已购错题本
        {
          path: '/ctb/list',
          name: 'CtbList',
          component: resolve => require(['@/views/ReportApp/components/ExamCtb/CtbList'], resolve),
          meta: { title: '已购错题本', hideHeader: true }
        },
        // 购买学币
        {
          path: '/study/coin/pay',
          name: 'StudyCoinPay',
          component: resolve => require(['@/views/ReportApp/components/StudyCoinPay'], resolve),
          meta: { title: '充值学币', hideHeader: true }
        },
      ]
    },
    // 404
    {
      path: '*',
      name: 'notFound',
      component: resolve => require(['@/views/ReportApp/components/NotFound'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/views/ReportApp/router/index.js